import { makeVar } from '@apollo/client'

export const userVar = makeVar<$TSFixMe>(null)
